import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '@workbuddy/ui/v2/surface.engine/core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '@workbuddy/ui/v2/surface.engine/core/runtime/surfaces/surface.schema.slots';

// Financial document form — Invoice, Bill, Quote, Sale Order, Purchase Order.
// Whole-document submit. Named section slots = host regions; entity schemas
// put fields into the right slot (no bind names in the host).
export const financialDocumentSurface = {
  id: SurfaceType.FinancialDocument,
  saveStrategy: 'submit',
  defaultFieldMode: 'edit',
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.FinancialDocument],
} as const satisfies SurfaceTypeDefinition<SurfaceType.FinancialDocument>;
